export default "__VITE_ASSET__DJfSeKO4__"